module.exports = __webpack_public_path__ + "static/media/Segment2.14a6fb27.jpg";